import script from "./ExtraVideoBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ExtraVideoBox.vue?vue&type=script&setup=true&lang=js"

import "./ExtraVideoBox.vue?vue&type=style&index=0&id=02a25f32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02a25f32"]])

export default __exports__